import moment from 'moment';

// TPE-2919: the per-survey "last view" marker (a localStorage date) drives ONLY the notification
// indicators — it answers "is there activity I haven't seen yet?". It is deliberately decoupled
// from the audit-log fetch window (which uses a fixed wide lookback). A row counts as unseen when
// it was created after the marker; when there is no marker yet (never viewed) everything is treated
// as new so the indicator still lights.
//
// This lives in a dependency-light util (only `moment`) rather than the assessment slice so that
// presentational components can read it without pulling in the auth/aws-amplify import chain.
export const isAuditLogAfterLastView = (
  createdAt: string | undefined,
  lastViewDate: string | undefined,
): boolean => {
  if (!lastViewDate) return true;
  if (!createdAt) return false;
  return moment(createdAt).isAfter(moment(lastViewDate));
};
